module.exports = __webpack_public_path__ + "img/settings.44f4dac7.svg";